import { render, staticRenderFns } from "./ResourceStatistics.vue?vue&type=template&id=695a6511&scoped=true&"
import script from "./ResourceStatistics.vue?vue&type=script&lang=js&"
export * from "./ResourceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a6511",
  null
  
)

export default component.exports